import errorHandler from './utils/errorHandler';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

errorHandler.logDebug('index', 'React app initializing');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

errorHandler.logDebug('index', 'React app rendered');

// Add a MutationObserver to detect any changes to the DOM
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'childList') {
      errorHandler.logDebug('index', 'DOM changed:', mutation);
    }
  });
});

observer.observe(document.body, { childList: true, subtree: true });